// extracted by mini-css-extract-plugin
export default {"container":"table_container__x2eVm","actionColumn":"table_actionColumn__H4bkg","state":"table_state__nJNHG","draft":"table_draft__elkJI","published":"table_published__ob2rd"};